import React, { useState, useRef, useEffect } from "react"
import { uploadFile } from "./upload_manager"

export default function FileUploader({ isMultiFile = false, commit = {
    repo_name: "Acm_Corp",
    username: "sujithvs",
    email: "sujithvs.think@gmail.com",
    commit_message: "Initial Commit",
    is_first_commit: true
}, back = () => { } }) {
    const inputRef = useRef();
    const inputcommitRef = useRef();
    const checkboxRef = useRef();
    const commitIdRef = useRef();
    const [files, setFiles] = useState([])
    const [error, setError] = useState('')


    function handleFiles(e) {

        const list = Array.from(e.target.files).map(file => ({

            file,
            progress: 0,
            speed: 0,
            remaining: 0

        }))

        setFiles(list)
    }

    function startUpload() {
        setError(undefined)
        if (inputcommitRef.current.value.length <= 3) {
            setError("Please add message")
            return
        }

        files.forEach((item, index) => {

            let ret = uploadFile(item.file, (progress, speed, remaining) => {

                setFiles(prev => {
                    const copy = [...prev]

                    copy[index].progress = progress
                    copy[index].speed = (speed / 1024 / 1024).toFixed(2)
                    copy[index].remaining = remaining.toFixed(1)

                    return copy
                })

            },
                // commit info need to add
                {
                    filename: item.file.name,
                    ...commit,
                    commit_message: inputcommitRef.current.value,
                    is_first_commit: checkboxRef.current.checked,
                    base_commit: commitIdRef.current.value,
                }
            )

            if (ret) {
                setError(ret)
            }

        })

    }

    const dropHandler = (e) => {

        e.preventDefault();

        handleFiles(e.dataTransfer.files);

    };

    return (
        <>

            <div style={styles.wrapper}>

                <h2>Upload Files to {commit.repo_name}</h2>

                <div
                    style={styles.dropZone}
                    onDrop={dropHandler}
                    onDragOver={(e) => e.preventDefault()}
                    onClick={() => inputRef.current.click()}
                >

                    <p>Drag & Drop files here</p>
                    <p>or</p>

                    <button style={styles.button}>
                        Choose Files
                    </button>

                    <input
                        type="file"
                        multiple={isMultiFile}
                        ref={inputRef}
                        style={{ display: "none" }}
                        onChange={(e) => handleFiles(e)}
                    />

                </div>
                <textarea required style={{ marginTop: 10 }} placeholder="Commit Messages" ref={inputcommitRef} ></textarea>
                <input readOnly defaultValue={commit?.base_commit} style={{ marginTop: 10 }} placeholder="Commit ID" ref={commitIdRef} />
                <div style={{ display: 'flex', gap: 10 }}>
                    <input style={{ maxWidth: 10, padding: 10 }}
                        checked={commit?.base_commit || true}
                        type="checkbox" ref={checkboxRef} />
                    <label style={{ width: '100%' }}> Is first commit?</label>
                </div>
                <div style={{ 'display': 'flex', gap: 4 }}>
                    <button style={styles.button} onClick={startUpload}>Upload</button>
                    <button style={styles.button} onClick={back}>Back</button>
                </div>
                {error && <div style={styles.error}>{error}</div>}

                <div style={{ marginTop: 20 }}>

                    {files.map((u, i) => (
                        <div key={i} style={styles.fileBox}>

                            <div>{u.file.name}</div>

                            <div style={styles.progressBar}>
                                <div
                                    style={{
                                        ...styles.progress,
                                        width: u.progress + "%"
                                    }}
                                ></div>
                            </div>

                            <div style={styles.meta}>

                                {u.progress}% |
                                Speed {u.speed} MB/s |
                                Remaining {u.remaining}s

                            </div>

                        </div>
                    ))}

                </div>

            </div>
        </>

    )


}
const styles = {

    wrapper: {
        maxWidth: 600,
        margin: "40px auto",
        background: "#fff",
        padding: 30,
        borderRadius: 10,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        fontFamily: "Arial"
    },

    dropZone: {
        border: "2px dashed #4a90e2",
        borderRadius: 10,
        padding: 40,
        textAlign: "center",
        cursor: "pointer",
        background: "#f9fbff"
    },

    button: {
        marginTop: 10,
        padding: "10px 20px",
        border: "none",
        background: "#4a90e2",
        color: "#fff",
        borderRadius: 6,
        cursor: "pointer"
    },

    fileBox: {
        marginTop: 20
    },

    progressBar: {
        width: "100%",
        height: 8,
        background: "#ddd",
        borderRadius: 5,
        overflow: "hidden"
    },

    progress: {
        height: "100%",
        background: "#4caf50"
    },

    meta: {
        fontSize: 12,
        marginTop: 5
    },
    error: {
        color: 'black',
        background: '#ff5d5d',
        padding: 2,
        borderRadius: 3,
        marginTop: 4
    }

};